import { callApi, handleError, handleResponse, getRequest, downloadRequest } from '@helpers/api';

const generateVatReturnRequest =
  agent =>
  ({ standardTemplate }) =>
    agent.post(`vFile/generateVatReturn/${standardTemplate}/`);
const getVatReturnEntryListRequest =
  agent =>
  ({ standardTemplate }) =>
    agent.get(`vFile/vatReturnEntry/${standardTemplate}/`);
const sendVatReturnEmailRequest =
  agent =>
  ({ listStandardTemplate }) =>
    agent.get(`vFile/vatReturnSendEmail/${listStandardTemplate}/`);
const vatReturnBankDetailsRequest =
  agent =>
  ({ standardTemplate }) =>
    agent.get(`vFile/vatReturnBankDetails/${standardTemplate}/`);
const getCzechEconomicActivityListRequest =
  agent =>
  ({ searchParam, limit, offset }) =>
    agent.get(
      `vFlow/czechEconomicActivity/?limit=${limit}&offset=${offset}&search=${searchParam || ''}`
    );

const getItalyVatReturnListRequest =
  agent =>
  ({ standardTemplate }) =>
    agent.get(`vFile/vatReturnEntryItalyVAT/${standardTemplate}/`);

export const generateVatReturn = async payload =>
  callApi(generateVatReturnRequest)(payload).then(handleResponse).catch(handleError);

export const getVatReturnEntryList = async payload =>
  callApi(getVatReturnEntryListRequest)(payload).then(handleResponse).catch(handleError);

/**
 * Downloads the draft return
 * @param {string} standardTemplateId - standard template ID
 * @returns {Promise<*|Object>}
 */
export const downloadVatReturn = standardTemplateId =>
  downloadRequest(`vFile/vatReturnDownload/${standardTemplateId}/`);

/**
 * Gets a list of files associated with the filed return
 * @param {string} id Filing ID
 * @returns {Promise<*|Object>}
 */
export const getFiledReturnFilesList = id =>
  getRequest('vFlow/savedFilingPeriodFile/', { saved_filing_period: id });

/**
 * Gets info for a saved filing period file
 * @param {string} id File ID
 * @returns {Promise<*|Object>}
 */
export const getFiledReturnFile = id => getRequest(`vFlow/savedFilingPeriodFile/${id}/`);

export const sendVatReturnEmail = async payload =>
  callApi(sendVatReturnEmailRequest)(payload).then(handleResponse).catch(handleError);

export const getVatReturnBankDetails = async payload =>
  callApi(vatReturnBankDetailsRequest)(payload).then(handleResponse).catch(handleError);

export const getCzechEconomicActivityList = async payload =>
  callApi(getCzechEconomicActivityListRequest)(payload).then(handleResponse).catch(handleError);

export const getItalyVatReturnList = async payload =>
  callApi(getItalyVatReturnListRequest)(payload).then(handleResponse).catch(handleError);
